module.exports = __webpack_public_path__ + "static/img/loading.accf8cb.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./static/images/loading.gif
 ** module id = 104
 ** module chunks = 3
 **/